import React from "react";
import Swal from 'sweetalert2';

function AppHeader({ client, user, loading, resetDni, isAuthenticated, goToHome }) {
    const getHeaderStyle = () => {
        if (isAuthenticated && client?.configuration) {
            const { header_color_0, header_color_1, header_text } = client.configuration;
            if (header_color_0 && header_color_1) {
                return {
                    background: `linear-gradient(150deg, ${header_color_0} 20%, ${header_color_1} 99%)`,
                    color: header_text || 'white'
                };
            }
        }
        // Gradiente por defecto (grises)
        return {
            background: 'linear-gradient(150deg, #f0f0f0 0%, #e0e0e0 99%)',
            color: 'white'
        };
    };

    const handleLogout = () => {
        Swal.fire({
            title: '¿Cerrar sesión?',
            text: "Se cerrará la ventana actual",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, cerrar sesión',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                resetDni();
                window.close();
            }
        });
    };

    return (
        <header className="fixed-top" style={getHeaderStyle()}>
            {isAuthenticated && (
                <div className="container py-3 ps-3">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        {client?.logo_url && (
                            <a onClick={goToHome} className="btn btn-link m-0 p-0">
                                <img 
                                    src={client.logo_url.startsWith('/') ? client.logo_url : `/${client.logo_url}`}
                                    alt={client.name}
                                    className="img-fluid"
                                    style={{ height: '30px' }}
                                />
                            </a>                            
                        )}
                        <button 
                            onClick={handleLogout} 
                            className="btn btn-link p-0 text-decoration-none d-flex align-items-center"
                            style={{ color: getHeaderStyle().color }}
                        >
                            <small className="me-1">Hola,</small> {user?.first_name || ''}
                            <i className="ms-2 bi bi-power icon-sm"></i>
                        </button>
                    </div>
                </div>
            )}
        </header>    
    );
}

export default AppHeader;